export default "__VITE_ASSET__HkQmIOGc__"